import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=5d5c2011"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=5d5c2011&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports